import { useMutation, useQueryClient } from '@tanstack/react-query';

import { LID_CACHE } from '@pkg/hooks/liquid-id/useGetLiquidIdItems';

import { callRemoveItemToLiquidId } from '@app/client/resources/nbe/liquid-id-request-handler';

export const useLiquidIdRemoveItem = () => {
    const queryClient = useQueryClient();
    return useMutation((item: string) => callRemoveItemToLiquidId({ value: { item } }), {
        onSuccess: () => {
            void queryClient.invalidateQueries({
                predicate: ({ queryKey }) => queryKey?.[0] === LID_CACHE,
            });
        },
    });
};
